<template>
  <div>
    <router-link :to="{name: 'masteries.detail', params: { id: id} }">
      <div class="flex flex-col mt-4 mb-4 mr-2 justify-start bg-white shadow-lg rounded-lg overflow-hidden w-72">
        <div class="flex flex-row section-title h-8 items-center">
          <span class="flex-grow">{{ title }}</span>
          <i
            v-if="showAddButton"
            class="fas fa-plus-circle mr-2 cursor-pointer"
            @click="onSelected(id)"
          />

          <i
            v-if="showRemoveButton"
            class="fa fa-times mr-2 cursor-pointer"
            @click="onRemoveSelected(id)"
          />
        </div>

        <div class="flex flex-col">
          <div
            v-if="functionalAllowed && links && links.length>0"
            class="flex flex-col text-xs mb-2"
          >
            <div
              v-for="link in links"
              :key="link.url"
              class="flex justify-center"
            >
              <iframe
                v-if="link.kind==6"
                id="vmplayer"
                :src="buildVimeoLink(link)"
                width="320"
                height="152"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
              />
              <iframe
                v-if="link.kind==7"
                id="ytplayer"
                type="text/html"
                width="320"
                height="152"
                :src="buildYoutubeLink(link)"
                frameborder="0"
              />

              <iframe
                v-if="link.kind==8"
                :src="buildgDriveLink(link)"
                width="320"
                height="152"
              />
            </div>
            <sc-difficulty
              v-if="difficulty && difficulty>0"
              :difficulty="difficulty"
            />
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
    name: 'MasteriesSmall',
    props: {
        title: {
            type: String,
            required: false
        },
        image: {
            type: String,
            required: false
        },
        difficulty: {
            type: Number,
            required: false
        },
        id: {
            type: String,
            required: false
        },
        links: {
            type: Array,
            required: false
        },
        showAddButton: {
            type: Boolean,
            required: false
        },
        showRemoveButton: {
            type: Boolean,
            required: false
        },

        mediaConsent: {
            type: Boolean,
            required: false
        }
    },
    data: function () {
        return {
            functionalAllowed: {
                type: Boolean,
                required: false
            }
        }
    },

    mounted () {
        const cookie = this.$cookies.get('cookiefirst-consent')
        const functional = cookie && cookie.functional
        this.functionalAllowed = functional
    },
    methods: {
        onSelected (item) {
            this.$emit('itemSelected', item)
        },

        onRemoveSelected (item) {
            this.$emit('removeItem', item)
        },

        onRemove () {
            this.$emit('removed', this.id)
        },
        buildYoutubeLink (link) {
            // TODO extract to api
            const src = 'https://www.youtube.com/embed/' + link.value
            return src
        },

        buildVimeoLink (link) {
            return 'https://player.vimeo.com/video/' + link.value + '?title=0&byline=0&portrait=0'
        },

        buildgDriveLink (link) {
            return 'https://drive.google.com/file/d/' + link.value + '/preview'
        }
    }
}
</script>

<style scoped>

</style>
